module.exports = __webpack_public_path__ + "static/media/ar.54914805.svg";